module.exports = __webpack_public_path__ + "static/media/react-logo.9978c2e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/react-logo.png
// module id = 413
// module chunks = 1